import { lazy } from "@loadable/component";
import { Suspense } from "react";
import { TenantBrandingSettingsLoading } from "./TenantBrandingSettings.loading";
import { ErrorBoundary } from "@sentry/react";
import { ErrorFallback } from "../../patterns";
import { TenantBrandingSettingsProps } from "./TenantBrandingSettings.types";

export const TenantBrandingSettingsLoadable = lazy(
  () => import("./TenantBrandingSettings")
);

export const TenantBrandingSettings = (props: TenantBrandingSettingsProps) => (
  <ErrorBoundary fallback={<ErrorFallback />}>
    <Suspense fallback={<TenantBrandingSettingsLoading />}>
      <TenantBrandingSettingsLoadable {...props} />
    </Suspense>
  </ErrorBoundary>
);
